module.exports = __webpack_public_path__ + "img/gautier_capucon.5928254f.jpg";